import { useMapboxInstance } from "#imports";
import { watchOnce } from "@vueuse/core";
export function useMapboxBeforeLoad(mapID, callback) {
  const map = useMapboxInstance(mapID);
  if (map.value)
    return callback(map.value);
  watchOnce(map, () => {
    if (map.value) {
      callback(map.value);
    }
  });
}
